module.exports = __webpack_public_path__ + "img/ic_location.9106449c.svg";